import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  blackColor,
  blackShade22,
  blueColor04,
  greyColor24,
  greyColor40,
  greyShade07,
  lightGreen04,
  lightSkyBlue01,
  mobilePrimary,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import InputPreview from "../../../components/Input/InputPreview";
import { useNavigate } from "react-router-dom";
import {
  ECOMMERCE_VIDEO_DATA,
  E_COMMERCE_STEP_LIST,
} from "../../../utils/data";
import { scrollBox, stickyHeader } from "../../../utils/styles";
import HowToLinkCard from "../../../components/Cards/HowToLinkCard";
import VideoModal from "../../../components/VideoModal";
import { ecomTabNavigationTo } from "../../../utils/helper";
import { toTitleCase } from "../../../utils/validationUtils";
import moment from "moment";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import {
  checkCatalogPartnerSettingApi,
  copyMasterBranchAuthApi,
} from "../../../service/api_calls/CatalogSync/CatalogSyncApi";
import { getCommerceInfo } from "../../../reducers/businessPreview/businessPreviewSlice";
import { useDispatch } from "react-redux";

function CatalogControlsContent({
  activeBusinessInfo,
  getCatalogPartnerAuth,
  catalogPartnerAuth,
  commerceInfo,
  inventorySummary,
}) {
  const dispatch = useDispatch();

  const businessId = sessionStorage.getItem("selectedBusinessId");
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [tabValue, setTabValue] = useState(6);
  const [openVideoModal, setOpenVideoModal] = useState(false);

  const [currentScreen, setCurrentScreen] = useState("none");
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    ecomTabNavigationTo(navigate, newValue);
  };

  const handleEditDetails = () => {
    navigate(`/${sessionStorage.getItem("costboWEBURL")}/editCatalogControls`);
  };

  const handleCloseVideoModal = () => {
    setOpenVideoModal(false);
  };

  const getActiveScreen = async () => {
    const catalogPartnerStatus =
      commerceInfo?.info?.catalogPartnerInfo?.[0]?.status || "";
    const totalProducts = inventorySummary?.totalProduct || 0;

    const isMainBranch =
      activeBusinessInfo?.mainBranch && !activeBusinessInfo?.mainBranchId;
    const isSubBranch =
      !activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId;
    const singleBranch =
      !activeBusinessInfo?.mainBranch && !activeBusinessInfo?.mainBranchId;

    // if (isSubBranch) {
    //   // Check whether catalog settings are defined in main branch or not
    //   const mainBranchId = activeBusinessInfo?.mainBranchId;
    //   const settingRes = await checkCatalogPartnerSettingApi(mainBranchId);

    //   if (settingRes?.checkCatalog) {
    //     // Allow Copy Auth from main branch

    //     const authRes = await getCatalogPartnerAuth(
    //       commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner || "buymore",
    //       // mainBranchId
    //       businessId
    //     );
    //     console.log("SUBBRANCH___", authRes);

    //     if (authRes?.status == "active") {
    //       if (
    //         commerceInfo?.info?.catalogPartnerInfo?.[0]?.warehouse?.facilityCode
    //       ) {
    //         setCurrentScreen("preview");
    //       } else {
    //         handleEditDetails();
    //       }
    //       return;
    //     }

    //     setCurrentScreen("branch-auth-copy");
    //     return;
    //   }
    // }

    // if (isMainBranch || singleBranch) {
    console.log("PAGE_REFRESH___:", { commerceInfo, totalProducts });

    await getCatalogPartnerAuth(
      commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner || "",
      businessId
    );

    // Info Message to Add Catalog Partner
    if (catalogPartnerStatus != "active" && totalProducts == 0) {
      console.log("PAGE_REFRESH___ADD:", { commerceInfo, totalProducts });
      setCurrentScreen("add-catalog");
    } else if (catalogPartnerStatus != "active" && totalProducts > 0) {
      console.log("PAGE_REFRESH___CA:", { commerceInfo, totalProducts });
      // Info Message - Catalog Already Defined with costbo
      setCurrentScreen("catalog-defined");
    } else if (catalogPartnerStatus == "active") {
      console.log("PAGE_REFRESH___PREVIEW:", { commerceInfo, totalProducts });
      setCurrentScreen("preview");
    }
    // }
  };

  // handle copy auth from main branch
  const handleCopyAuth = async () => {
    setLoader(true);

    const res = await copyMasterBranchAuthApi({
      mainBranchId: activeBusinessInfo?.mainBranchId,
      // catalogPartner: commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner || "",
      // catalogPartner: "buymore",
      subBranchId: businessId,
    });

    if (true) {
      setTimeout(() => {
        dispatch(getCommerceInfo(businessId));
        handleEditDetails();
      }, 2000);
    }
  };

  useEffect(() => {
    if (commerceInfo && inventorySummary) {
      getActiveScreen();
    }
    return () => {};
  }, [commerceInfo]);

  return (
    <Box flex={1}>
      {openVideoModal && (
        <VideoModal
          open={openVideoModal}
          handleClose={handleCloseVideoModal}
          data={ECOMMERCE_VIDEO_DATA}
        />
      )}
      <Box sx={stickyHeader} pb={1.5}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={{ xs: "row", md: "row" }}
          mb="10px"
        >
          <Typography
            variant="h2"
            fontSize={{ md: 17, xs: 17 }}
            fontWeight={600}
            color={greyColor24}
            lineHeight="28px"
          >
            E-Commerce Controls
          </Typography>
          <HowToLinkCard
            link="E-Commerce Controls"
            handleClick={() => {
              setOpenVideoModal(true);
              // navigate("/howToVideoGuides", {
              //   state: { status: "eCommerceControls" },
              // });
            }}
            justifyContent="flex-start"
          />
        </Box>
        <Box
          sx={{
            ...scrollBox,
            display: "block",
            borderBottom: 1,
            borderColor: "divider",
            mb: { xs: "10px", md: 1 },
          }}
        >
          <Tabs
            variant="scrollable"
            value={tabValue}
            onChange={(event, newValue) => handleChange(event, newValue)}
            aria-label="basic tabs example"
            textColor={blackColor}
            TabIndicatorProps={{
              style: {
                height: "3px",
                backgroundColor: matches ? blueColor04 : mobilePrimary,
              },
            }}
            sx={{
              minHeight: "35px !important",
              "& .MuiButtonBase-root": {
                minWidth: "auto !important",
              },
            }}
          >
            {E_COMMERCE_STEP_LIST?.map((item, index) => {
              return (
                <Tab
                  key={"filter_" + index}
                  label={item.label}
                  // label={item.label}
                  sx={{
                    fontSize: { xs: "13px", md: "13.5px" },
                    fontWeight: tabValue == index ? 500 : 500,
                    p: 0,
                    minHeight: "30px !important",
                    mr: { xs: "20px", md: "55px" },
                    color:
                      item.id === tabValue
                        ? matches
                          ? blueColor04
                          : mobilePrimary
                        : greyColor40,
                    textTransform: "capitalize",
                  }}
                />
              );
            })}
          </Tabs>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h4"
            fontSize={15}
            fontWeight={600}
            color={greyColor24}
            lineHeight="28px"
            mb="4px"
          >
            Catalog Controls
          </Typography>

          {currentScreen == "preview" && (
            <Button onClick={handleEditDetails} sx={styles.editBtn}>
              EDIT
            </Button>
          )}
        </Box>
      </Box>

      <Box sx={styles.card}>
        {/* UI to copy auth from main branch to sub-branch */}
        {currentScreen == "branch-auth-copy" && (
          <InfoMessageCard
            icon={
              <CategoryOutlinedIcon
                sx={{ fontSize: "30px", color: blueColor04 }}
              />
            }
            title="Copy auth from main branch"
            message={`Catalog partner settings are already defined in the main branch level. Click the 'Copy Auth' button to \ncopy the credentials from main branch.`}
            btnText="COPY AUTH"
            onClick={handleCopyAuth}
            loader={loader}
          />
        )}

        {/* Info Message to Add Catalog Partner */}
        {currentScreen == "add-catalog" && (
          <InfoMessageCard
            icon={
              <CategoryOutlinedIcon
                sx={{ fontSize: "30px", color: blueColor04 }}
              />
            }
            title="Add Catalog Partner Info"
            message="Provide the catalog partner details to easily sync all your existing products with CostBo."
            btnText="ADD CONTROLS"
            onClick={handleEditDetails}
          />
        )}

        {/* Info Message - Catalog Already Defined with costbo */}
        {currentScreen == "catalog-defined" && (
          <InfoMessageCard
            icon={
              <ChecklistOutlinedIcon
                sx={{ fontSize: "30px", color: blueColor04 }}
              />
            }
            title="Catalog already defined with CostBo"
            message={`Catalog partner cannot be added \b
              ${inventorySummary?.totalProduct} ${
              inventorySummary?.totalProduct > 1 ? "products" : "product"
            } have already been added directly within the CostBo.`}
          />
        )}

        {/* Show Preview if catalog partner defined */}
        {currentScreen == "preview" && (
          <Box mt="5px">
            <Box>
              <TitleText title="Catalog Partner" />

              <Box m="6px 0 0 16px">
                <InputPreview
                  label="Catalog Partner"
                  value={
                    toTitleCase(
                      commerceInfo?.info?.catalogPartnerInfo?.[0]
                        ?.catalogPartner
                    ) || "-"
                  }
                  styles={{ mb: 0 }}
                  valueStyles={{ fontWeight: 500 }}
                  hideBorder
                />
              </Box>
            </Box>

            <Box mt={1}>
              <TitleText
                title={`Credential for ${toTitleCase(
                  commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner ||
                    ""
                )}`}
              />

              <Box ml={2}>
                {/* <Typography
                fontSize={{ xs: 12, md: 13 }}
                fontWeight={400}
                color={greyColor40}
                mb={1.5}
                lineHeight="18px"
              >
                You can provide an existing API key or create a new one in the
                Unicommerce dashboard.{" "}
                <span
                  style={{
                    color: blueColor04,
                    fontWeight: 500,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    window.open("https://auth.unicommerce.com/login", "_blank");
                  }}
                >
                  Click here
                </span>
              </Typography> */}

                {commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner?.toLowerCase() ==
                  "unicommerce" && (
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", md: "row" }}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    gap={{ xs: 1, md: 4.5 }}
                    mt={1}
                  >
                    <InputPreview
                      label="Base Url"
                      value={catalogPartnerAuth?.baseURL || "-"}
                      styles={{ mb: 0 }}
                      valueStyles={{ fontWeight: 500 }}
                      hideBorder
                    />

                    <InputPreview
                      label="Channel Code"
                      value={catalogPartnerAuth?.channel || "-"}
                      styles={{ mb: 0 }}
                      valueStyles={{ fontWeight: 500 }}
                      hideBorder
                    />
                  </Box>
                )}

                <Box
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  alignItems={{ xs: "flex-start", md: "center" }}
                  gap={{ xs: 1, md: 4.5 }}
                  mt={1}
                >
                  <InputPreview
                    label="Username"
                    value={catalogPartnerAuth?.userId || "-"}
                    styles={{ mb: 0 }}
                    valueStyles={{ fontWeight: 500 }}
                    hideBorder
                  />

                  <InputPreview
                    label="Last Updated On"
                    value={
                      commerceInfo?.info?.catalogPartnerInfo?.[0]?.updatedDate
                        ? moment(
                            commerceInfo?.info?.catalogPartnerInfo?.[0]
                              ?.updatedDate
                          ).format("Do MMM YYYY")
                        : "-"
                    }
                    styles={{ mb: 0 }}
                    valueStyles={{ fontWeight: 500 }}
                    hideBorder
                  />
                </Box>
              </Box>
            </Box>

            <Box mt={1}>
              <TitleText title="Warehouse" />

              <Box ml={2} mt={1}>
                {/* <Typography
                  fontSize={13}
                  fontWeight={400}
                  color={greyColor40}
                  mb={1.5}
                  lineHeight="18px"
                >
                  {`You can find all your Unicommerce warehouse codes (facility codes) by navigating to Settings > Facilities in your Unicommerce dashboard.`}
                </Typography> */}

                <Grid container rowGap={0.5}>
                  <Grid item xs={6} md={2}>
                    <InputPreview
                      label="Warehouse Name"
                      value={
                        commerceInfo?.info?.catalogPartnerInfo?.[0]?.warehouse
                          ?.facilityName || `-`
                      }
                      styles={{ mb: 0 }}
                      hideBorder
                    />
                  </Grid>

                  <Grid item xs={6} md={10}>
                    <InputPreview
                      label="Warehouse Code"
                      value={
                        commerceInfo?.info?.catalogPartnerInfo?.[0]?.warehouse
                          ?.facilityCode || `-`
                      }
                      styles={{ mb: 0 }}
                      hideBorder
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default CatalogControlsContent;

const InfoMessageCard = ({
  icon,
  title,
  message,
  btnText,
  onClick,
  loader,
}) => {
  return (
    <Stack alignItems="center" mt={3}>
      <Box sx={styles.infoCardIcon}>{icon}</Box>

      <Typography fontSize={14.5} fontWeight={500} color={blackColor} mt={2}>
        {title}
      </Typography>

      <Typography
        fontSize={12.5}
        fontWeight={400}
        color={greyColor24}
        mt={0.5}
        mb={1.5}
        textAlign="center"
        sx={{ whiteSpace: "pre-line", lineHeight: "20px" }}
      >
        {message}
      </Typography>

      {btnText && (
        <Button
          onClick={onClick}
          sx={styles.editBtn}
          disabled={loader}
          startIcon={loader && <CircularProgress size={16} color="inherit" />}
        >
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

const TitleText = ({ title, subtitle }) => {
  return (
    <Box display="flex" alignItems="center" gap="8px">
      <Box sx={styles.dotUi} />

      <Typography
        component="h6"
        fontSize={14}
        color={greyColor24}
        fontWeight={600}
        lineHeight="18px"
      >
        {title}{" "}
        <Typography
          component="span"
          fontSize={12.5}
          color={greyShade07}
          fontWeight={400}
          ml="5px !important"
        >
          {subtitle}
        </Typography>
      </Typography>
    </Box>
  );
};

const styles = {
  card: {
    p: { xs: "10px 15px", md: "10px 20px 20px" },
    backgroundColor: whiteColor,
    boxShadow: "0 0px 4px 0 rgb(0 0 0 / 5%)",
    borderRadius: { xs: "8px", md: "13px" },
    mt: { xs: "5px", md: "0px" },
  },

  iconContainer: {
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "25px",
    backgroundColor: "#e5e8ee",
  },

  noDataText: {
    fontSize: 14,
    fontWeight: 500,
    color: greyColor24,
    lineHeight: "24px",
  },

  editBtn: {
    backgroundColor: blackShade22,
    padding: "2px 14px",
    fontSize: "12px",
    fontWeight: 600,
    color: whiteColor,
    border: "1.5px solid " + blackShade22,
    textTransform: "unset",
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      borderColor: "rgba(0,0,0,0.04)",
      backgroundColor: "rgba(0,0,0,0.1)",
    },
  },

  dotUi: {
    width: "6px",
    height: "6px",
    borderRadius: "3px",
    backgroundColor: greyColor24,
    mt: -0.2,
  },

  infoCardIcon: {
    width: "60px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: lightSkyBlue01,
    borderRadius: "10px",
  },
};
